import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export function setupI18n(localeConfig: any) {
  // for all options read: https://www.i18next.com/overview/configuration-options
  return i18n.use(initReactI18next).init({
    debug: !!localeConfig.debug,
    load: 'languageOnly',
    lng: localeConfig.code || 'en',
    preload: ['en'],
    initImmediate: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    resources: localeConfig.resources,
    react: {
      useSuspense: false
    }
  });
}
